import { transactionLaneConstants } from "./action-types";
import { transactionLaneDataApi } from "../utils/api";
import dotEnv from "dotenv";
import { message } from "antd";
import { offerTableHandle } from "../../OfferTable/state/actions";
import { contractStoreHandle } from "../../ContractStore/state/actions";
import { detectWebView, getOmdUrlId } from "../../Common/utils/universalFuntions";
import { createOfferContractTypes } from "../../Common/commondata/commonData";
import { appStatusChange } from "../../App/state/actions";
import { commonConstants } from "../../Common/state/action-types";
dotEnv.config();
/**
 * All Actions for contract Page
 */

/**
 * @param {string}
 */

const getTransactionLaneError = (error) => {
  return {
    type: transactionLaneConstants.GET_TRANSACTION_LANE_IN_RTD_FAILURE,
    getTransactionLaneError: error,
    getTransactionLaneLoading: false,
  };
};

const getTranscactionLaneSucess = (response) => {
  return {
    type: transactionLaneConstants.GET_TRANSACTION_LANE_IN_RTD_SUCCESS,
    getTransactionLaneData: response.data.info,
    getTransactionLaneLoading: false,
  };
};

const getTransactionLaneLoading = (responce) => {
  return {
    type: transactionLaneConstants.GET_TRANSACTION_LANE_IN_RTD_LOADING,
    getTransactionLaneLoading: responce,
  };
};

const getTransactionLaneMethod = (id, role,userAuthKey, transactionType, propertyId) => {
  
  return (dispatch, getState) => {
    dispatch(getTransactionLaneLoading(true));
    transactionLaneDataApi
      .transactionLaneApi(id, role,userAuthKey, transactionType, propertyId)
      .then((response) => {
        dispatch(getTranscactionLaneSucess(response));
        dispatch(getTransactionLaneLoading(false));
      })
      .catch((error) => {
        dispatch(getTransactionLaneError(error));
      });
  };
};

const updateDocument = ({documentId, data, client,userAuthKey,offerId, emailSignatureId, emailMessage}) => {

  return (dispatch, getState) => {
    dispatch(contractStoreHandle.setTransparentDivLoading({
      loadingStatus: true,
    }));
    transactionLaneDataApi
      .updateDocumentApi({documentId, data, userAuthKey, emailSignatureId, emailMessage})
      .then((response) => {
        message.success(response.data.info?.message || "Document Sent Successfully!");
        dispatch(getTransactionLaneMethod(offerId,client,userAuthKey))
      })
      .then(() =>  dispatch(contractStoreHandle.setTransparentDivLoading({
        loadingStatus: false,
      })))
      .catch((error) => {
        dispatch(contractStoreHandle.setTransparentDivLoading({
          loadingStatus: false,
        }));
        message.error(error?.response?.data?.message || "Failed to send document!");
        // dispatch(updatetDocumentFailure(error));
      });
  };
};

// Email actions
const sendEmailLoading = () => {
  return {
    type: transactionLaneConstants.SEND_EMAIL_LOADING,
  };
};
const sendEmailError = (error) => {
  return {
    type: transactionLaneConstants.SEND_EMAIL_FAILURE,
    sendEmailError: error,
  };
};

const sendEmailSuccess = (response) => {
  return {
    type: transactionLaneConstants.SEND_EMAIL_SUCCESS,
    sendEmailData: response.data.info,
  };
};

const sendEmailToClients = (data) => {
  return (dispatch, getState) => {
    let userAuthKey = getState()?.offerTable?.offerTableAuthKey;
    dispatch(sendEmailLoading());
    transactionLaneDataApi
      .sendEmailToClientRequest(data,userAuthKey)
      .then((response) => {
        dispatch(sendEmailSuccess(response));
        message.success("Document Sent Succesfully!");
      })
      .catch((error) => {
        dispatch(sendEmailError(error));
        message.error(error?.response?.data?.message || "We encountered an issue while sending email to clients.Please try again later!");
      });
  };
};

const addEmailFunLoading = () => {
  return {
    type:transactionLaneConstants.ADD_EMAIL_LOADING,
  }
}

const addEmailFunError = () => {
  return {
    type:transactionLaneConstants.ADD_EMAIL_ERROR,
  }
}

const addEmailFunSuccess = () => {
  return {
    type:transactionLaneConstants.ADD_EMAIL_SUCCESS,
  }
}

const callIndividualApi = (data) => {
  return {
    type: commonConstants.CALL_INIDIVIDUAL_API,
    callAction: data
  }
}

const addEmailFun = ({data, userAuthKey, source, setEnterEmailModal,enterEmailModal,documentId,setIsEmailModalVisible, isEmailModalVisible,form, setCallPropertyDocsApi, currentUrlId, clientType, localData, setRootLevelEmailChanged, origin}) => {
  return (dispatch, getState) => {
    dispatch(addEmailFunLoading())
    const offerTableAuthKey = getState()?.offerTable?.offerTableAuthKey;
    const offerTablePropertyId = getState()?.offerTable?.offerTablePropertyId;
    transactionLaneDataApi.addEmailRequest(["CONTRACT_NAV_SELLER_AGENT", "CONTRACT_NAV_BUYER_AGENT", "TRANSACTION_CALENDAR", "AVATAR_DATA", "AVATAR_PAGE_REFRESH"].includes(source) ? userAuthKey : offerTableAuthKey, data)
    .then((response) => {
      dispatch(addEmailFunSuccess())
      if(!response?.data?.info?.showClients){
        message.success("Email added successfully");
        // if(setIsEmailModalVisible){
        //   setIsEmailModalVisible({ ...isEmailModalVisible, isEmailModalOpen: false, sendMultipleDoc: false });
        // }
        if(source === "SHARE_INDIVIDUAL_OFFER"){
          dispatch(offerTableHandle.getOfferTable(offerTableAuthKey,offerTablePropertyId, null, null, null, "SELLER_AGENT"))
        }
        if(source === 'TRANSACTION_CALENDAR' || source === "CLIENT_PORTAL"){
          setCallPropertyDocsApi(true);
        }
        if(origin === "WY" && source === "CONTRACT_NAV_BUYER_AGENT"){
          dispatch(callIndividualApi(true))
        }
        if(source === "AVATAR_DATA"){
          dispatch(contractStoreHandle.renderClientData())
        }
        if(source === "AVATAR_PAGE_REFRESH"){
          window.location.reload();
        }
        if(currentUrlId){
          dispatch(contractStoreHandle.autoSaveContract({ currentUrlId, contractAuthKey: userAuthKey, valueObj: { [clientType]: localData?.[clientType] } }));
        }
        if(setRootLevelEmailChanged){
          setRootLevelEmailChanged(true);
        }
        form?.resetFields();
      }else{
        if(setEnterEmailModal){
          setEnterEmailModal({...enterEmailModal,data:{showClients:response?.data?.info?.showClients, allClients: response?.data?.info?.allClients}})
        }
      }

    })
    .catch((error) => {
      console.log(error, "errrorrr")
      dispatch(addEmailFunError())
      message.error(error?.response?.data?.message || "We encountered an issue while adding email.Please try again later!");
    })
  }
}
// Dora docs
const getDoraDocumentsLoading = () => {
  return {
    type: transactionLaneConstants.GET_DORA_DOCUMENTS_LOADING,
  };
};
const getDoraDocumentsError = (error) => {
  return {
    type: transactionLaneConstants.GET_DORA_DOCUMENTS_FAILURE,
    getDoraDocumentsError: error,
    getDoraDocumentsLoading: false,
  };
};

const getDoraDocumentsSuccess = (response) => {
  return {
    type: transactionLaneConstants.GET_DORA_DOCUMENTS_SUCCESS,
    getDoraDocumentsData: response,
    getDoraDocumentsLoading: false,
  };
};

const getDoraDocumentsData = (data, accessToken,fiters) => {
  return (dispatch) => {
    dispatch(getDoraDocumentsLoading());
    transactionLaneDataApi
      .getNestedDoraDocuments(data, accessToken,fiters)
      .then((response) => {
        dispatch(getDoraDocumentsSuccess(response.data.info));
      })
      .catch((error) => {
        dispatch(getDoraDocumentsError(error));
      });
  };
};
const triggerUploadedPdf = () => {
  return {
    type: transactionLaneConstants.UPLOAD_DOCUMENT_PDF_SUCCESS
  }
}
const UploadedDocPdfLoad = (loading) => {
  return {
    type:transactionLaneConstants.UPLOAD_DOCUMENT_PDF_LOADER,
    action: loading
  }
}
const uploadPdfDocumentFunc = ({data, successFunc},accessToken,offerId,unmounted) => {
  return (dispatch, getState) => {
    dispatch(appStatusChange.loadOpacityLoader(true));
    transactionLaneDataApi
      .uploadPdfDocument({data},accessToken)
      .then((response) => {
        message.success(response?.data?.info?.message || "Document Uploaded Successfully!");
        dispatch(appStatusChange.loadOpacityLoader(false));
        if(successFunc){
          successFunc();
        }
        dispatch(triggerUploadedPdf());
        dispatch(getIndividualTransaction({offerId,userAuthKey:accessToken,unmounted}))
        dispatch(getTransactionLaneMethod(offerId,"SELLER",accessToken))
      })
      .catch((error) => {
        dispatch(appStatusChange.loadOpacityLoader(false));
        message.error(error?.response?.data?.message || "We encountered an issue while uploading the document. Please try again later!");
      });
  }
}

// get emailtemplate List
const get_Email_Template_Loading = () => {
  return {
    type: transactionLaneConstants.GET_EMAIL_TEMPLATE_LOADING,
  };
};
const get_Email_Template_Error = (error) => {
  return {
    type: transactionLaneConstants.GET_EMAIL_TEMPLATE_FAILURE,
  };
};
const get_Email_Template_Success = (response) => {
  return {
    type: transactionLaneConstants.GET_EMAIL_TEMPLATE_SUCCESS,
    getEmail_Templatedata: response.data.info,
  };
};

const getEmail_Template = (userAuthKey) => {
  return (dispatch) => {
    dispatch(get_Email_Template_Loading());
    transactionLaneDataApi
      .getemailtemplateRequest(userAuthKey)
      .then((response) => {
        dispatch(get_Email_Template_Success(response));
      })
      .catch((error) => {
        dispatch(get_Email_Template_Error(error));
      });
  };
};
// Dradocs URl shorting
const doraDocsUrlShorthandFailure = (error) => {
  return {
    type: transactionLaneConstants.DORADOCS_SHORTHAND_URL_FAILURE,
    doraDocsUrlShorthandLoading: false,
    doraDocsUrlShorthandError: error,
  };
};

const doraDocsUrlShorthandSuccess = (response) => {
  return {
    type: transactionLaneConstants.DORADOCS_SHORTHAND_URL_SUCCESS,
    doraDocsUrlShorthandData: response,
    doraDocsUrlShorthandLoading: false,
  };
};

const doraDocsUrlShorthandLoading = (response) => {
  return {
    type: transactionLaneConstants.DORADOCS_SHORTHAND_URL_LOADING,
    doraDocsUrlShorthandLoading: response,
  };
};

const doraDocsUrlShorthandApiCalling = ({ buildData, history, source }) => {
  return async (dispatch) => {
    try {
      dispatch(doraDocsUrlShorthandLoading(true));
      const response = await transactionLaneDataApi.urlShorthandApi(buildData);
      if (!response?.data?.info?._id) {
        message.error("We encountered an issue while opening document. Please try again later.");
      }
      dispatch(doraDocsUrlShorthandSuccess(response.data.info._id));
      const query = new URLSearchParams(window.location?.search || "");
      if (query?.get("dest") === "OMD") {
        query.set("dest", "RTD");
      } else if (query?.get("dest") === "TC_OMD") {
        query.set("dest", "TC_RTD");
      }
      const queryString = query?.toString();
      const documentPath = `/contractDocument/${response.data.info._id}`;
      const finalUrl = queryString ? `${documentPath}?${queryString}` : documentPath;
      if (source === "CREATE_COUNTER_OFFER") {
        if (detectWebView()) {
          window.location.href = finalUrl; 
        } else {
          window.open(finalUrl, "_blank");
        }
      } else {
        const omdUrlId = createOfferContractTypes.includes(buildData?.contractType) ? getOmdUrlId() : null;
        history.push(`${documentPath}?sameOrigin=true${omdUrlId ? `&omdUrlId=${omdUrlId}` : ""}`);
      }
    } catch (error) {
      dispatch(doraDocsUrlShorthandFailure(error));
    }
  };
};

//update && Email phone
const updateEmailError = (error) => {
    return {
      type: transactionLaneConstants.UPDATE_EMAIL_FAILURE,
      updateEmailError: error,
      updateEmailLoading: false,
    };
  };


  const updateEmail = (values,personId,offerTableAuthKey,offerTablePropertyId,source) => {
    return (dispatch, getState) => {
        dispatch(addEmailFunLoading())
        transactionLaneDataApi
        .updateEmailRequest(values,personId,offerTableAuthKey)
        .then((response) => {
          // dispatch(updateEmailSuccess(response));
          dispatch(addEmailFunSuccess())
          if(offerTablePropertyId){
            dispatch(offerTableHandle.getOfferTable(offerTableAuthKey,offerTablePropertyId, null, null, null, "SELLER_AGENT"))
          }
          message.success("Updated Successfully!", 2);
        })
        .catch((error) => {
          message.error(
            error?.response?.data?.message || "We encountered an issue while updating email.Please try again later!"
          );
          dispatch(updateEmailError(error));
        });
    };
  };

  //update Transaction Email
  const updateTransactionEmailLoading = (error) => {
    return {
      type: transactionLaneConstants.UPDATE_EMAIL_FAILURE,
      updateEmailError: error,
      updateEmailLoading: false,
    };
  };

const updateTransactionEmailError = (error) => {
    return {
      type: transactionLaneConstants.UPDATE_EMAIL_FAILURE,
      updateEmailError: error,
      updateEmailLoading: false,
    };
  };

  const updateTransactionEmailSuccess = (response) => {
    return {
      type: transactionLaneConstants.UPDATE_EMAIL_SUCCESS,
      updateEmailDetails: response.data.info,
      updateEmailLoading: false,
    };
  };

  const getSharedDocsLoading = () => {
    return {
      type: transactionLaneConstants.GET_SHARED_DOCS_LOADING,
    };
  };
  const getSharedDocsError = (error) => {
    return {
      type: transactionLaneConstants.GET_SHARED_DOCS_FAILURE,
    };
  };

  const getSharedDocsSuccess = (response) => {
    return {
      type: transactionLaneConstants.GET_SHARED_DOCS_SUCCESS,
      getSharedDocsData: response.data.info,
    };
  };

  const getSharedDocsFun = ({offerId, userAuthKey, openFor}) => {
    return (dispatch, getState) => {
      dispatch(getSharedDocsLoading());
      transactionLaneDataApi
        .getSharedDocsRequest({offerId, userAuthKey, openFor})
        .then((response) => {
          dispatch(getSharedDocsSuccess(response));
        })
        .catch((error) => {
          dispatch(getSharedDocsError(error));
          message.error(error?.response?.data?.message || "We encountered an issue while fetching shared document data. Please try again later!");
        });
    };
  };
  const triggerIndividualTransactionFetch = (payload) => {
    return {
      type: transactionLaneConstants.TRIGGER_INDIVIDUAL_TRANSACTION_FETCH,
      payload
    };
  };

  const getIndividualTransactionLoading = () => {
    return {
      type: transactionLaneConstants.GET_INDIVIDUAL_TRANSACTION_LOADING,
    };
  };
  const getIndividualTransactionSuccess = (response) => {
    return {
      type: transactionLaneConstants.GET_INDIVIDUAL_TRANSACTION_SUCCESS,
      getIndividualTransactionData: response.data.info
    };
  };
  const getIndividualTransactionError = (error) => {
    return {
      type: transactionLaneConstants.GET_INDIVIDUAL_TRANSACTION_FAILURE,
      errorMsg: error?.response?.data?.message || "Failed to fetch individual transaction data!",
    };
  };
  const getIndividualTransaction = ({offerId, propertyId, setLoading, sourceAxios, unmounted, delegateSide, delegateOwnerId,userAuthKey, openFor}) => {
    return (dispatch, getState) => {
      if (setLoading) {
        setLoading(true);
      } else {
        dispatch(getIndividualTransactionLoading());
      }
      transactionLaneDataApi
        .individualTransactionApi({offerId, propertyId, sourceAxios, delegateSide, delegateOwnerId,userAuthKey, openFor})
        .then((response) => {
          if(!unmounted.value){
            dispatch(getIndividualTransactionSuccess(response));
            dispatch(callIndividualApi(false))
            if (setLoading) {
              setLoading(false);
            }
          }
        })
        .catch((error) => {
          if(!unmounted.value){
            dispatch(getIndividualTransactionError(error));
            message.error(error?.response?.data?.message || "Failed to fetch individual transaction data!");
            if (setLoading) {
              setLoading(false);
            }
          }
        });
    };
  };

const deletePropertyContractDocs = ({ payloadData }) => {
  return (dispatch, getState) => {
    const { offerId, role, token } = payloadData
    transactionLaneDataApi
      .deletePropertyContractDocsRequest({ payloadData })
      .then((response) => {
        if (response) {
          message.success(response?.data?.info?.message || "Document Deleted Successfully!");
          dispatch(getTransactionLaneMethod(offerId, role, token))
        }
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Error occured while deleting document!");
        dispatch(getTransactionLaneError(error));
      });
  };
};

const triggerTransactionLaneData = () => {
  return {
    type: transactionLaneConstants.TRIGGER_TRANSACTION_LANE_API
  }
}

const deletePropertyContractDocsFun = ({payloadData, userAuthKey}) => {
  return (dispatch, getState) => {
    dispatch(appStatusChange.loadOpacityLoader(true));
    transactionLaneDataApi
      .deletePropertyContractDocsFunRequest({payloadData, userAuthKey})
      .then((response) => {
        if (response) {
          message.success("Document Deleted Successfully!");
        } 
        dispatch(appStatusChange.loadOpacityLoader(false));
        if(payloadData?.requiresRender){
          dispatch(uploadPropertyDocsSuccess());
        }
        dispatch(triggerTransactionLaneData());
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Error occured while sharing property docs data!");
        dispatch(appStatusChange.loadOpacityLoader(false));
      });
  };
};

const getClientDocRequestLoading = (error) => {
  return {
    type: transactionLaneConstants.GET_CLIENT_DOC_LOADING,
    uploadPdfError: error,
    uploadPdfLoading: false,
  };
};

const getClientDocRequestSuccess = (response) => {
  return {
    type: transactionLaneConstants.GET_CLIENT_DOC_SUCCESS,
    propertyDocs: response?.data?.info,
    uploadPdfLoading: false,
  };
};

const getClientDocRequestError = (error) => {
  return {
    type: transactionLaneConstants.GET_CLIENT_DOC_ERROR,
    uploadPdfError: error,
    uploadPdfLoading: false,
  };
};

// const getPropertyDocsFun = ({params, unmounted, source,type, userAuthKey}) => {
//   return (dispatch, getState) => {
//     if((type==="SendEmail") || (type === "commonSendEmail")){ 
//       dispatch(getPropertyDocWithoutSectionLoading())
//     }else{
//     dispatch(getClientDocRequestLoading());
//     }
//     transactionLaneDataApi
//       .getClientDocRequest({params, source, userAuthKey})
//       .then((response) => {
//         if(!unmounted?.value){
//           if(type==="SendEmail"){ 
//              dispatch(getPropertyDocWithoutSectionSuccess(response?.data?.info));
//             }else if(type === "commonSendEmail"){
//               dispatch(getPropertyDocWithoutSectionSuccess(response?.data?.info?.transactionDocs, response?.data?.info?.contactDocs));
//             }else{
//             dispatch(getClientDocRequestSuccess(response));
//             }
//          }
//       })
//       .catch((error) => {
//         if(!unmounted?.value){
//           if(type==="SendEmail"){ 
//           dispatch(getPropertyDocWithoutSectionError(error));
//         }else{
//           dispatch(getClientDocRequestError(error));
//         }message.error(
//             error?.response?.data?.message || "Error occured while getting property docs data!",
//           );
//         }
//       });
//   };
// };

const EmailFileDataError = (error) => {
  return {
    type: transactionLaneConstants.EMAIL_FILES_ERROR,
    emailFilesError: error,
    emailFilesLoading: false,
  };
};

const EmailFileDataLoading = () => {
  return {
    type: transactionLaneConstants.EMAIL_FILES_LOADING,
    emailFilesLoading: true,
  };
};
const EmailFileDataSuccess = (response) => {
  return {
    type: transactionLaneConstants.EMAIL_FILES_SUCCESS,
    payload: response.data.info.emails,
  };
};

const EmailFileData = (data,userAuthKey) => {
  return (dispatch) => {
    dispatch(EmailFileDataLoading());
    transactionLaneDataApi
      .getEmails_FilesApi(data,userAuthKey)
      .then((response) => {
        dispatch(EmailFileDataSuccess(response));
        // let redirectURL = `${apiURL}/contractDocument/${JSON.parse(urlId)}`
        // window.location.assign(encodeURI(redirectURL));
      })
      .catch((error) => {
        dispatch(EmailFileDataError(error?.response?.data?.message || "Error occured while getting email files data!"));
      });
  };
};

const clientPortalError = (error) => {
  return {
    type: transactionLaneConstants.CLIENT_PORTAL_ERROR,
    setError: error,
    setLoading: false,
  };
};

const clientPortalLoading = () => {
  return {
    type: transactionLaneConstants.CLIENT_PORTAL_LOADING,
    setLoading: true,
  };
};
const clientPortalSuccess = (response) => {
  return {
    type: transactionLaneConstants.CLIENT_PORTAL_SUCCESS,
    payload: response.data.info,
  };
};

const ClientPortalData = ({query, data, userAuthKey}) => {
  return (dispatch) => {
    dispatch(clientPortalLoading());
    transactionLaneDataApi
      .getClientScreen(query, userAuthKey)
      .then((response) => {
        dispatch(clientPortalSuccess(response));
      })
      .catch((error) => {
        dispatch(clientPortalError(error?.response?.data?.message || "Error occured while getting client portal data!"));
      });
  };
};

const generateDashboardLinkLoading = () => {
  return {
    type: transactionLaneConstants.GENERATE_DASHBOARD_LINK_LOADING,
  };
};
const generateDashboardLinkSuccess = (dashboarUrl) => {
  return {
    type: transactionLaneConstants.GENERATE_DASHBOARD_LINK_SUCCESS,
    dashboarUrl,
  };
};
const generateDashboardLinkError = () => {
  return {
    type: transactionLaneConstants.GENERATE_DASHBOARD_LINK_ERROR,
  };
};
const generateDashboardLinkFun = (payload, userAuthKey) => {
  return (dispatch) => {
    dispatch(generateDashboardLinkLoading());
    transactionLaneDataApi
      .generateDashboardLinkApi(payload, userAuthKey)
      .then((response) => {
        dispatch(generateDashboardLinkSuccess(response.data.info?.url));
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Currently, we are unable to generate the link for you. Please try again later. If the issue persists, please contact RE-Sure Support.");
        dispatch(generateDashboardLinkError());
      });
  };
};

const toggleFolderOpenState = (folderId) => {
  return {
    type: transactionLaneConstants.TOGGLE_FOLDER_OPEN_STATE,
    folderId,
  }
};

const resetFolderOpenState = () => {
  return {
    type: transactionLaneConstants.RESET_FOLDER_OPEN_STATE,
  }
}

const uploadPropertyDocsError = (error) => {
  return {
    type: transactionLaneConstants.UPLOAD_DOCUMENT_FAILURE,
    uploadPdfError: error,
    uploadPdfLoading: false,
  };
};

const uploadPropertyDocsLoading = (error) => {
  return {
    type: transactionLaneConstants.UPLOAD_DOCUMENT_LOADING,
    uploadPdfError: error,
    uploadPdfLoading: false,
  };
};

const uploadPropertyDocsSuccess = (response) => {
  return {
    type: transactionLaneConstants.UPLOAD_DOCUMENT_SUCCESS,
    propertUploadDocs: response?.data?.info,
    uploadPdfLoading: false,
  };
};

const getPropertyDocsFunUpload = ({params,source,userAuthKey}) => {
  return (dispatch, getState) => {
    dispatch(uploadPropertyDocsLoading());
    transactionLaneDataApi
      .getClientDocRequest({params,source,userAuthKey})
      .then((response) => {
        dispatch(uploadPropertyDocsSuccess(response));
      })
      .catch((error) => {
        dispatch(uploadPropertyDocsError(error));
        message.error(error?.response?.data?.message || "Error occured while uploading property docs!");
      });
  };
};

const uploadPropertyDocsFun = (data, userAuthKey) => {
  return (dispatch, getState) => {
    dispatch(appStatusChange.loadOpacityLoader(true));
    transactionLaneDataApi
      .uploadPropertyDocsRequest(data, userAuthKey)
      .then((response) => {
        message.success(response?.data?.info?.message || "File Uploaded Successfully!");
        dispatch(appStatusChange.loadOpacityLoader(false));
        dispatch(uploadPropertyDocsSuccess());
      })
      .catch((error) => {
        dispatch(appStatusChange.loadOpacityLoader(false));
        message.error(
          error?.response?.data?.message || "We encountered an issue while uploading property docs. Please try again later!",
        );
      });
  };
};

const sharePropertyDocs = (payloadData, requiresRender, userAuthKey) => {
  return (dispatch, getState) => {
    dispatch(appStatusChange.loadOpacityLoader(true));
    transactionLaneDataApi
      .sharePropertyDocsRequest(payloadData,userAuthKey)
      .then((response) => {
        if (payloadData.unShare) {
          message.success("Document unshared Successfully!");
        } else {
          message.success("Document Shared Successfully!");
        }
        dispatch(appStatusChange.loadOpacityLoader(false));
        dispatch(triggerTransactionLaneData());
        if(requiresRender){
          dispatch(uploadPropertyDocsSuccess());
        }
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Error occured while sharing property docs data!");
        dispatch(appStatusChange.loadOpacityLoader(false));
      });
  };
};

const triggerGetPersonDocsFun = () => {
  return {
    type: transactionLaneConstants.TRIGGER_GET_PERSON_DOCS
  }
}

const deleteListing = ({ docId, filterSort = {}, delegateOwnerId, source, userAuthKey }) => {
  return (dispatch, getState) => {
    dispatch(appStatusChange.loadOpacityLoader(true));
    transactionLaneDataApi
      .deleteListingRequest({ docId, delegateOwnerId, userAuthKey })
      .then((response) => {
        message.success(response?.data?.info?.message || "Deleted Successfully!");
        if (source === "CLIENT_SCREEN") { 
          dispatch(triggerGetPersonDocsFun());
        } else if (source === "PROPERTY_CLIENT_DOCS") {
          dispatch(uploadPropertyDocsSuccess());
        } else {
          // dispatch(changeFilterSort({ ...filterSort }));
        }
        dispatch(appStatusChange.loadOpacityLoader(false));
      })
      .catch((error) => {
        dispatch(appStatusChange.loadOpacityLoader(false));
        message.error(error?.response?.data?.message || "Error occured while deleting listing!");
      });
  };
};

const removePropertyDocsFun = (docId, userAuthKey) => {
  return (dispatch) => {
    dispatch(appStatusChange.loadOpacityLoader(true));
    transactionLaneDataApi
    .deletepropertyDocsRequest(docId, userAuthKey)
      .then((response) => {
        message.success(response?.data?.info?.message || "File Deleted Successfully!");
        dispatch(appStatusChange.loadOpacityLoader(false));
        dispatch(uploadPropertyDocsSuccess());
        dispatch(triggerTransactionLaneData());
      })
      .catch((error) => {
        dispatch(appStatusChange.loadOpacityLoader(false));
        message.error( error?.response?.data?.message || "We encountered an issue while deleting property docs data. Please try again later!");
      });
  };
}

const toggleDocumentInTransactionDashboard = ({payloadData, userAuthKey}) => {
  return (dispatch, getState) => {
    dispatch(appStatusChange.loadOpacityLoader(true));
    transactionLaneDataApi
      .toggleDocumentInTransactionDashboardRequest({payloadData, userAuthKey})
      .then((response) => {
        if (response) {
          message.success(response?.data?.info?.message);
        } 
        dispatch(appStatusChange.loadOpacityLoader(false));
        if(payloadData?.requiresRender){
          dispatch(uploadPropertyDocsSuccess());
        }
        dispatch(triggerTransactionLaneData());
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Error occured while sharing property docs data!");
        dispatch(appStatusChange.loadOpacityLoader(false));
      });
  };
};

const getMoveToFolderFunSuccess = (response) => {
  return {
    type: transactionLaneConstants.GET_MOVE_TO_FOLDER_DATA_SUCCESS,
    moveToFolderData: response,
  }
}

const getMoveToFolderFunLoading = () => {
  return {
    type: transactionLaneConstants.GET_MOVE_TO_FOLDER_DATA_LOADING,
  }
}

const getMoveToFolderFunError = () => {
  return {
    type: transactionLaneConstants.GET_MOVE_TO_FOLDER_DATA_ERROR,
  }
}



const getMoveToFolderFun = ({ params, userAuthKey }) => {
  return (dispatch, getState) => {
    dispatch(getMoveToFolderFunLoading())
    transactionLaneDataApi
      .getMoveToFolderFunRequest({ params, userAuthKey })
      .then((response) => {
        dispatch(getMoveToFolderFunSuccess(response?.data?.info))
      })
      .catch((error) => {
        dispatch(getMoveToFolderFunError());
        message.error(
          error?.response?.data?.message || "We encountered an issue while getting the folder data. Please try again later!",
        );
      });
  };
};

const moveToFolderFun = ({params, userAuthKey}) => {
  return (dispatch) => {
    dispatch(appStatusChange.loadOpacityLoader(true));
    transactionLaneDataApi.moveToFolderFunRequest({params, userAuthKey})
    .then((response) => {
      dispatch(appStatusChange.loadOpacityLoader(false));
      dispatch(uploadPropertyDocsSuccess());
      message.success(response?.data?.info?.message || "Document successfully moved to the folder.");
    })
    .catch((error) => {
      dispatch(appStatusChange.loadOpacityLoader(false));
      message.error(
        error?.response?.data?.message || "We encountered an issue while moving files into the folder. Please try again later!",
      );
    })
  }
}

const downloadAllFilesAsZipRequestLoading = () => {
  return {
    type: transactionLaneConstants.DOWNLOAD_ALL_FILES_AS_ZIP_REQUEST_LOADING,
  }
}
const downloadAllFilesAsZipRequestSuccess = () => {
  return {
    type: transactionLaneConstants.DOWNLOAD_ALL_FILES_AS_ZIP_REQUEST_SUCCESS,
  }
}

const downloadAllFilesAsZip = ({payload, userAuthKey}) => {
  return (dispatch, getState) => {
    dispatch(downloadAllFilesAsZipRequestLoading());
    transactionLaneDataApi.downloadAllFilesAsZipRequest(payload, userAuthKey)
    .then((response) => {
        const blob = new Blob([response.data], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", "Re-Sure_Documents.zip");
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

      dispatch(downloadAllFilesAsZipRequestSuccess());
      message.success("Your file has been downloaded successfully!");
    })
    .catch((error) => {
      message.error(error?.response?.data?.message || "We encountered an issue while downloading the zip, Please try again later!");
    })
  }
}

const getDocTemplateDataLoading = () => {
  return {
    type: transactionLaneConstants.GET_TEMPLATE_DOC_SET_LOADING
  }
}

const getDocTemplateDataError = () => {
  return {
    type: transactionLaneConstants.GET_TEMPLATE_DOC_SET_ERROR
  }
}

const getDocTemplateDataSuccess = (response) => {
  return {
    type: transactionLaneConstants.GET_TEMPLATE_DOC_SET_SUCCESS,
    docSetTemplateData: response
  }
}

const getDocTemplateData = ({contractType, userAuthKey}) => {
  return (dispatch) => {
    dispatch(getDocTemplateDataLoading())
    transactionLaneDataApi.templateDataRequest({contractType, userAuthKey})
    .then((response) => {
      dispatch(getDocTemplateDataSuccess(response?.data?.info))
    })
    .catch((error) => {
      dispatch(getDocTemplateDataError())
      message.error(error?.response?.data?.message || "Error occured while getting template data!");
    })
  }
}

const getPreDoraDocumentsLoading = () => {
  return {
    type: transactionLaneConstants.GET_PRE_DORA_DOCUMENTS_LOADING,
  };
};
const getPreDoraDocumentsError = (error) => {
  return {
    type: transactionLaneConstants.GET_PRE_DORA_DOCUMENTS_FAILURE,
    getPreDoraDocumentsError: error,
    getPreDoraDocumentsLoading: false,
  };
};

const getPreDoraDocumentsSuccess = (response) => {
  return {
    type: transactionLaneConstants.GET_PRE_DORA_DOCUMENTS_SUCCESS,
    getPreDoraDocumentsData: response,
    getPreDoraDocumentsLoading: false,
  };
};

const getPreDoraDocumentsData = ({data, unmounted, source, fiters, brokerageId, userAuthKey}) => {
  return (dispatch) => {
    dispatch(getPreDoraDocumentsLoading());
    transactionLaneDataApi
      .getPreNestedDoraDocuments({data, source, fiters, brokerageId, userAuthKey})
      .then((response) => {
        if(!unmounted.value){
          dispatch(getPreDoraDocumentsSuccess(response.data.info));
        }
      })
      .catch((error) => {
        if(!unmounted.value){
          dispatch(getPreDoraDocumentsError(error));
          message.error(error?.response?.data?.message || "We encountered an issue while getting dora documents data. Please try again later!");
        }
      });
  };
};

const createFolderFun = ({ newFolderData, userAuthKey }) => {
  return (dispatch, getState) => {
    dispatch(appStatusChange.loadOpacityLoader(true));
    transactionLaneDataApi
      .createFolderRequest({ newFolderData, userAuthKey })
      .then((response) => {
        message.success(response?.data?.info?.message || "Folder Created Successfully!");
        dispatch(appStatusChange.loadOpacityLoader(false));
        dispatch(uploadPropertyDocsSuccess());
      })
      .catch((error) => {
        dispatch(appStatusChange.loadOpacityLoader(false));
        message.error(
          error?.response?.data?.message || "We encountered an issue while creating folder. Please try again later!",
        );
      });
  };
};

const updatePropertyDocsFolderFun = ({ folderData, userAuthKey }) => {
  return (dispatch, getState) => {
    dispatch(appStatusChange.loadOpacityLoader(true));
    transactionLaneDataApi
      .updateFolderRequest({ folderData, userAuthKey })
      .then((response) => {
        message.success(response?.data?.info?.message || "File Moved to Folder Successfully!");
        dispatch(appStatusChange.loadOpacityLoader(false));
        dispatch(uploadPropertyDocsSuccess());
      })
      .catch((error) => {
        dispatch(appStatusChange.loadOpacityLoader(false));
        message.error(
          error?.response?.data?.message || "We encountered an issue while creating folder. Please try again later!",
        );
      });
  };
};

const deletePropertyDocFolder = (folderId, userAuthKey) => {
  return (dispatch) => {
    dispatch(appStatusChange.loadOpacityLoader(true));
    transactionLaneDataApi.deletePropertyDocFolder(folderId, userAuthKey)
    .then((response) => {
      dispatch(appStatusChange.loadOpacityLoader(false));
      dispatch(uploadPropertyDocsSuccess());
      message.success(response?.data?.info?.message || "Folder Deleted Successfully.");
    })
    .catch((error) => {
      dispatch(appStatusChange.loadOpacityLoader(false));
      message.error(error?.response?.data?.message || "We encountered an issue while deleting the folder. Please try again later!");
    })
  }
}

const changeDocName = ({urlData, documentId, userAuthKey}) => {
  return (dispatch) => {
    dispatch(appStatusChange.loadOpacityLoader(true));
    transactionLaneDataApi.changeDocNameApi(urlData,documentId, userAuthKey)
    .then((response) => {
      message.success("Document name changed successfully.");
      dispatch(appStatusChange.loadOpacityLoader(false));
      dispatch(uploadPropertyDocsSuccess());
      dispatch(triggerTransactionLaneData())
    })
    .catch((error) => {
      dispatch(appStatusChange.loadOpacityLoader(false));
      message.error(error?.response?.data?.message || "We encountered an issue while renaming, Please try again later!");
    })
  }
}

const get_RE_Sure_Sign_Doc_Loading = () => {
  return {
    type: transactionLaneConstants.GET_RESURE_SIGN_DOC_LOADING,
  };
};
const get_RE_Sure_Sign_Doc_Error = (error) => {
  return {
    type: transactionLaneConstants.GET_RESURE_SIGN_DOC_ERROR,
   };
};

const get_RE_Sure_Sign_Doc_Success = (response) => {
  // setselectedData(response?.data?.info?.[0])
  return {
    type: transactionLaneConstants.GET_RESURE_SIGN_DOC_SUCCESS,
    RE_SureSignDocData: response?.data?.info,
  };
};
const getResure_SignDocs = (userAuthKey) => {
  return (dispatch) => {
    dispatch(get_RE_Sure_Sign_Doc_Loading());
    transactionLaneDataApi.getResure_SignDocs(userAuthKey)
    .then((response) => {
        dispatch(get_RE_Sure_Sign_Doc_Success(response));
     
    })
    .catch((error) => {
      message.error(error?.response?.data?.message|| "Error occured while getting Resure Sign Docs");
      dispatch(get_RE_Sure_Sign_Doc_Error());

    })
  }
}
const import_Resure_Sign_Success = (response) => {
 
  return {
    type: transactionLaneConstants.IMPORT_RESURE_SIGN_DOC_SUCCESS,
    importResureSignSuccess: true
  };
};
const importRe_sure_sign_docs = (payload,userAuthKey) => {
  return (dispatch) => {
    transactionLaneDataApi
      .importResure_SignDocs(payload,userAuthKey)
      .then((res) => {
        dispatch(import_Resure_Sign_Success())
        if (res?.data?.info?.message) {
          message.success(res?.data?.info?.message || "Imported RE-Sure Sign Docs successfully!");
        }
        dispatch(uploadPropertyDocsSuccess());
        dispatch(triggerTransactionLaneData());
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Error occured while importing Resure Sign Docs!");
      });
  };
};

const generateresureSignUrl =  ({ buildData,userAuthKey }) => {
  return (dispatch, getState) => {
    dispatch(appStatusChange.loadOpacityLoader(true));
    transactionLaneDataApi
      .generateresureSignApi(buildData,userAuthKey)
      .then((response) => {
        const redirectUrl = response?.data?.info?.redirectUrl;
        if (redirectUrl) {
          window.open(redirectUrl);
        } else {
          message.error("Redirect URL not found!");
        }
        dispatch(appStatusChange.loadOpacityLoader(false));
      })
      .catch((error) => {
        message.error(error?.response?.data?.message || "Error occured while getting resure Sign document data!");
        dispatch(appStatusChange.loadOpacityLoader(false));
      });
  };
}
export const transactionLaneDataHandle = {
  sendEmailToClients,
  getTransactionLaneMethod,
  updateDocument,
  getTranscactionLaneSucess,
  getDoraDocumentsData,
  getEmail_Template,
  doraDocsUrlShorthandApiCalling,
  updateEmail,
  addEmailFun,
  getSharedDocsFun,
  getIndividualTransaction,
  deletePropertyContractDocs,
  deletePropertyContractDocsFun,
  triggerIndividualTransactionFetch,
  uploadPdfDocumentFunc,
  // getPropertyDocsFun,
  EmailFileData,
  ClientPortalData,
  generateDashboardLinkFun,
  resetFolderOpenState,
  toggleFolderOpenState,
  sharePropertyDocs,
  uploadPropertyDocsFun,
  deleteListing,
  removePropertyDocsFun,
  toggleDocumentInTransactionDashboard,
  getMoveToFolderFun,
  moveToFolderFun,
  downloadAllFilesAsZip,
  getDocTemplateData,
  getPreDoraDocumentsData,
  createFolderFun,
  updatePropertyDocsFolderFun,
  deletePropertyDocFolder,
  getPropertyDocsFunUpload,
  changeDocName,
  getResure_SignDocs,
  importRe_sure_sign_docs,
  generateresureSignUrl
};
